import React from 'react';
import Slot from '../board/Slot';
import DraggableCard from '../card/DraggableCard';

const PlayerDeck = ({ player, playerDeck, moveCard, canMoveCard }) => {
  return playerDeck.map((card, index) => (
    <div key={`${card.special || card.pal}-${card.num}`}>
      <Slot
        moveCard={() => moveCard(index)}
        canMoveCard={item => canMoveCard(item, card, player)}
      >
        <DraggableCard card={card} player={player} index={index} />
      </Slot>
    </div>
  ));
};

export default PlayerDeck;
